export const DEFAULT_SOURCE_PREVIEW_HEIGHT = 240;
export const MIN_SOURCE_PREVIEW_HEIGHT = 120;
export const MAX_SOURCE_PREVIEW_HEIGHT = 480;
export const SOURCE_ASSET_AREA_RESERVE = 120;
export const SOURCE_PREVIEW_TRANSPORT_RESERVE = 56;

export function sourcePreviewHeightLimits(panelHeight, headerHeight) {
  const reserve = Math.min(SOURCE_ASSET_AREA_RESERVE, panelHeight * 0.4);
  // In exceptionally short panels, asset space yields to the visible transport;
  // the existing outer scrollbar still exposes the grid below it.
  const max = Math.floor(Math.max(SOURCE_PREVIEW_TRANSPORT_RESERVE,
    Math.min(MAX_SOURCE_PREVIEW_HEIGHT, panelHeight - headerHeight - reserve)));
  return { min: Math.min(MIN_SOURCE_PREVIEW_HEIGHT, max), max };
}
